import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Notificacao } from '../shared/models/notificacao.model';
import BrowserUtils from '../shared/utils/browser-utils';
import { ApiService } from '../shared/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacoesService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getNotificacoes(): Promise<Notificacao[]> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-mensageria-portal',
      path: '/cobranca-mensageria-portal/notificacao',
      oldBrowserFallbackPath: '/notificacao'
    })

    return this.http.get<Notificacao[]>(path, {}).toPromise();
  }

  marcarComoLida(id: string): Promise<any> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-mensageria-portal',
      path: `/cobranca-mensageria-portal/notificacao/${id}`,
      oldBrowserFallbackPath: `/notificacao/${id}`,
    })

    return this.http.patch(path, { visualizado: true }).toPromise();
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}/v1`;
    }

    return `${environment.apiURLService}/v1`;
  }

}
